import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
    async addNewReview(context, payload = {}) {
        //payload : DAM Users JSON schema
    
        try {
          let resp = await axios.post(Constants.reviewdataurl, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[addNewReview][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[addNewReview][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },

      async addNewParentComment(context, payload = {}) {
        try {
          let resp = await axios.put(Constants.indReviewdataurl+"/"+payload.reviewId+"/comments", payload.params);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[addNewParentComment][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[addNewParentComment][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              try{
                error.response.data.statusCode = error.response.status
                return error.response.data
              }catch(e){
                throw new Error(e);
              }
            }
          }
          return {}
        }
    
      },

      async addNewReplyComment(context, payload = {}) {
        try {
          let resp = await axios.put(Constants.indReviewdataurl+"/"+payload.reviewId+"/comments", payload.params);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[addNewReplyComment][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[addNewReplyComment][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },

      async updateReviewData(context, payload = {}) {
        try {
          let resp="";
          if(payload.modules == "Task"){
            if('taskType' in payload && payload.taskType == "Ticket"){
              resp = await axios.put(Constants.ticketUrl+"/"+payload.reviewId, payload.params);
            }else{  
              resp = await axios.put(Constants.tasksUrl+"/"+payload.reviewId, payload.params);
            }  
          }else if(payload.modules == "project"){
            resp = await axios.put(Constants.projectsUrl+"/"+payload.reviewId, payload.params);
          }else{
            resp = await axios.put(Constants.indReviewdataurl+"/"+payload.reviewId, payload.params);
          }
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[updateReviewData][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateReviewData][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },

      async updateCommentData(context, payload = {}) {
        try {
          let resp = "";
          if(payload.commentModule == "Task"){
            if('taskType' in payload && payload.taskType == "Ticket"){
              resp = await axios.put(Constants.ticketUrl+"/"+payload.reviewId+"/comments", payload.params);  
            }else{
              resp = await axios.put(Constants.tasksUrl+"/"+payload.reviewId+"/comments", payload.params);
            }  
          }else{
            resp = await axios.put(Constants.indReviewdataurl+"/"+payload.reviewId+"/comments", payload.params);
          }
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[updateReviewData][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateReviewData][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },
      
      async deleteCommentFromReview(context, payload = {}) {
        try {
          let resp = "";
          if(payload.commentModule == "Task"){
            resp = await axios.delete(Constants.tasksUrl+"/"+payload.commentId+"/comments", payload);
          }else{
              resp = await axios.delete(Constants.indReviewdataurl+"/"+payload.commentId+"/comments", payload);
          }

          
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[deleteCommentFromReview][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[deleteCommentFromReview][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },

      async getServerReviewCommentListData(context, payload = {}) {
        let reviewId = payload["review_id"];
        try {
          let resp = await axios.get(Constants.reviewParentCommentGetUrl+"/"+reviewId, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[getServerReviewCommentListData][Store][Error occured while getServerReviewCommentListData report list--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async getChatUsersFromServer(context, payload = {}) {
        try {
          let resp = await axios.get(Constants.messageUsersUrl, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[getChatUsersFromServer][Store][Error occured while getChatUsersFromServer report list--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async getReviewUsersWithAutocomplete(context, payload = {}) {
        try {
          let userUrl = Constants.reviewUsers;
          if(payload.params && 'userId' in payload.params){
            userUrl += '/' + payload.params.userId;
            delete payload.params.userId
          }
          let resp = await axios.get(userUrl, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[getReviewUsersWithAutocomplete][Store][Error occured while getReviewUsersWithAutocomplete report list--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },
};
